import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild } from '@angular/core';
import { AsamcoUserService } from '@asamco/base';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MarketPlaceItem } from '../../interfaces/market-place-item.interface';
import { LinkDescriptionService } from '../../services/link-description.service';
import { LinkEditInfoModalComponent } from '../link-edit-info-modal/link-edit-info-modal.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'al-link-edit-support',
    templateUrl: './link-edit-support.component.html',
    styleUrls: ['./link-edit-support.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, LinkEditInfoModalComponent],
})
export class LinkEditSupportComponent implements OnInit {
	@ViewChild(LinkEditInfoModalComponent)
	editInfoModal: LinkEditInfoModalComponent;

	@Input()
	linkInfo: MarketPlaceItem;

	private destroy$ = new Subject<void>();
	public admin: boolean;

	constructor(private linkDescriptionService: LinkDescriptionService, private asamcoUserService: AsamcoUserService) {}

	ngOnInit(): void {
		this.asamcoUserService.isAdmin().then(result => (this.admin = result));
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	openModal(): void {
		if (this.admin === false) return;
		else {
			this.editInfoModal
			.show('pricing information', this.linkInfo.supportInformation)
			.pipe(takeUntil(this.destroy$))
			.subscribe(result => {
				this.linkInfo.supportInformation = result;
				this.linkDescriptionService.setSupportInformation(this.linkInfo.id, result).pipe(takeUntil(this.destroy$)).subscribe({error: console.error});
			});
		}
	}
}
